import { Box } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import React from 'react'

interface SettlementDetailKpiItemProps {
  detailContent: React.ReactNode
  isLoading?: boolean
}

export const SettlementDetailKpiItem: React.FC<SettlementDetailKpiItemProps> = ({
  detailContent,
  isLoading = false
}) => {
  return (
    <Box
      style={{
        padding: '16px',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {isLoading ? (
        <Box style={{ width: '100%' }}>
          <Skeleton variant="text" width="80%" height={30} style={{ marginBottom: 8 }} />
          <Skeleton variant="text" width="60%" height={30} style={{ marginBottom: 8 }} />
          <Skeleton variant="text" width="70%" height={30} />
        </Box>
      ) : (
        detailContent
      )}
    </Box>
  )
}
